// Reusable 2x2 grid of L2 nested metric cards for SLD detail panel

export interface QuadMetric {
  label: string;
  value: number | string | null | undefined;
  unit?: string;
  icon?: string;
  color?: string;
}

interface MetricQuadGridProps {
  metrics: QuadMetric[];
}

function formatValue(value: unknown): string {
  if (value == null) return '--';
  if (typeof value === 'number') {
    if (Math.abs(value) >= 1000) return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
    if (Math.abs(value) >= 100) return value.toFixed(0);
    if (Math.abs(value) >= 10) return value.toFixed(1);
    return value.toFixed(1);
  }
  return String(value);
}

export function MetricQuadGrid({ metrics }: MetricQuadGridProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {metrics.slice(0, 4).map((m) => (
        <div
          key={m.label}
          className="rounded-xl bg-ems-bg p-2.5 flex flex-col items-center justify-center gap-0.5 min-h-[60px]"
        >
          {m.icon && <span className="text-sm leading-none">{m.icon}</span>}
          <span className="text-[10px] text-ems-text-muted uppercase tracking-wide text-center leading-tight">
            {m.label}
          </span>
          <span className={`text-sm font-mono font-semibold transition-all duration-300 ${m.color ?? 'text-ems-text-primary'}`}>
            {formatValue(m.value)}
            {m.unit && m.value != null && (
              <span className="text-[10px] font-normal text-ems-text-muted ml-0.5">{m.unit}</span>
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
